import React, { useEffect } from 'react'
import { images } from '../../assets/images'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ShowErrorMsg } from '../../utils/ShowErrorMsg'

const JoinOptions = ({ isCounselor }) => {

   // 애플 심사 때문에 웹뷰일 때는 애플 로그인 로직 추가
   const isWebView = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      return /wv|webview|ip(hone|ad|od).*safari/i.test(userAgent);
   }

   const handleClickAppleLogin = () => {
      // alert('준비 중입니다.');
      // return;
      if (isWebView()) {
         window.postMessage(JSON.stringify({ key: 'APPLE_LOGIN' }));
      } else {
         window.location.href = `${process.env.REACT_APP_API_URL}/login/${isCounselor ? '1' : '0'}/apple`
      }
   }

   const afterSocialLogin = async (event) => {
      let result = null;
      // alert(event.data) 

      if (event && event.data && typeof event.data === 'string') {
         try {
            result = JSON.parse(event.data);
         } catch (e) {
            console.error("Invalid JSON data:", e);
         }
      }


      try {
         const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/${isCounselor ? '1' : '0'}/apple/app`, {
            id_token: result.value.idToken,
            email: result.value.email,
            fullName: result.value.fullName,
         }, {
            withCredentials: true // 쿠키 전송 및 저장 허용
         })

         if (response.data.data.type === 1) {
            alert('성공적으로 처리되었습니다.')
         }
         window.location.href = response.data.data.url;
      } catch (error) {
         ShowErrorMsg(error)
      }

   }

   useEffect(() => {
      window.addEventListener('message', afterSocialLogin);
      document.addEventListener('message', afterSocialLogin);

      return () => {
         window.removeEventListener('message', afterSocialLogin);
         document.removeEventListener('message', afterSocialLogin);
      }
   }, [])

   return (
      <div className="subpage">
         <section className="user-section">
            <div className="user-wrap">
               <div className="title-wrap row-group">
                  <h2 className="title">
                     회원가입
                  </h2>
                  <p className="txt">
                     SNS 1초 간편가입으로 마인드 인사이트의 다양한 프로그램을 만나보세요!
                  </p>
               </div>
               <div
                  style={!isCounselor ? { borderBottom: '0px' } : {}}
                  className="login-sns-wrap"
               >
                  <Link
                     to={`${process.env.REACT_APP_API_URL}/login/${isCounselor ? '1' : '0'}/naver`}
                     className="btn"
                  >
                     <img src={images.never_login} alt="" />
                  </Link>
                  <Link
                     to={`${process.env.REACT_APP_API_URL}/login/${isCounselor ? '1' : '0'}/kakao`}
                     className="btn"
                  >
                     <img src={images.kakao_login} alt="" />
                  </Link>
                  {/* <Link
                     to={`${process.env.REACT_APP_API_URL}/login/${isCounselor ? '1' : '0'}/apple`}
                     className="btn"
                  >
                     <img src={images.apple_login} alt="" />
                  </Link> */}
                  <button
                     onClick={handleClickAppleLogin}
                     className="btn"
                  >
                     <img src={images.apple_login} alt="" />
                  </button>
                  <Link
                     to={`${isCounselor ? '/join/counselor/email' : '/join/email'}`}
                     className="btn email">
                     <i className="icon"></i>
                     이메일로 회원가입하기
                  </Link>
               </div>
               {isCounselor &&
                  <>
                     <p className="sub">
                        상담사 회원이신가요?
                     </p>
                     <Link to="/login/counselor" className="join-btn">상담사 로그인</Link>
                  </>
               }
            </div>
         </section>
      </div>
   )
}

export default JoinOptions